/**
 * Rapports › Activités : conversion d'affichage heures → unité choisie.
 *
 * JS pur (sans React) : testé par `api/scripts/testReportUnits.ts`.
 * Le backend reste en heures ; la conversion ne se fait qu'à l'affichage.
 */

import { hoursToDays } from './units.js';

/**
 * Heures → valeur affichée. Jours : 3 décimales max (0,375 j = 3 h) ;
 * heures : 1 décimale (inchangé). Renvoie un nombre, donc sans zéros
 * inutiles (8 h → 1 j). null/undefined → null.
 */
export function convertReportHours(hours, isDays) {
  if (hours == null) return null;
  if (isDays) return Math.round(hoursToDays(hours) * 1000) / 1000;
  return Math.round(Number(hours) * 10) / 10;
}

// Colonnes de l'export Time tracking (valeur exacte) : `timetrackingExport.js`.
